import { useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button';
import { BusinessUnitDetailDialog } from '~/shared/components/ui/Dialog';

export const UISampleBusinessUnitDetailDialogs = () => {
  const [result, setResult] = useState('');
  const [isShowConfirm, setIsShowConfirm] = useState(false);

  return (
    <div className="categories">
      <h3 id="dialog">取引先詳細ダイアログ</h3>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setResult('');
                setIsShowConfirm(true);
              }}
            />
            <BusinessUnitDetailDialog
              isOpen={isShowConfirm}
              inputOption={{
                clientCompanyId: 'A9999A01',
                clientCompanyName: 'XX1製作所',
                clientStaffName: '鈴木太郎',
                clientStaffEmail: 'aaa@gmail.com',
                clientAssistantName: '山田花子',
                clientAssistantEmail: 'bbb@gmail.com',
                selfStaffName: '営業太郎',
                selfCompanyDepartment: 'XXXXカンパニー',
              }}
              onCancel={() => {
                setIsShowConfirm(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">{result}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
